<template>
  <div>
    <div @click="focusInput">
                    <input
                    v-model="search"
                    @input="updateSearchResults"
                    @keyup="globalSearch"
                    ref="searchInput"
                    class="w-full py-2 text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 px-2"
                    type="search"
                    placeholder="Search"
                    style="min-width: 200px"
                  />
                  </div>
    <vue-good-table
      :columns="columns"
      :rows="rows.data"
      :search-options="{
            enabled: false,
            skipDiacritics: true,
            placeholder: 'Cerca un cliente'
        }"
        :pagination-options="false"
       theme="polar-bear">
        <template slot="table-row" slot-scope="props">

           <span v-if="props.column.field == 'appointment'">
              <span v-if="props.row.theachievements.get_one == 1" class="block w-3 h-3 bg-green-400 rounded-full"></span><span v-else class="block w-3 h-3 bg-red-500 rounded-full"></span>
            </span>
            <span v-if="props.column.field == 'event'">
              <span v-if="props.row.theachievements.get_event == 1" class="block w-3 h-3 bg-green-400 rounded-full"></span><span v-else class="block w-3 h-3 bg-red-500 rounded-full"></span>
            </span>
            <span v-if="props.column.field == 'app'">
              <span v-if="props.row.theachievements.get_app == 1" class="block w-3 h-3 bg-green-400 rounded-full"></span><span v-else class="block w-3 h-3 bg-red-500 rounded-full"></span>
            </span>
            <span v-if="props.column.field == 'book'">
              <span v-if="props.row.theachievements.get_book == 1" class="block w-3 h-3 bg-green-400 rounded-full"></span><span v-else class="block w-3 h-3 bg-red-500 rounded-full"></span>
            </span>

            <span v-if="props.column.field == 'qrcode'">
              <span v-if="props.row.iprofile_token != null">✅</span>
              <span v-else>❌</span>
            </span>
         
            <span v-if="props.column.field == 'action'">
            <span style="font-weight: bold;">
                <a class="mx-2 bg-green-600 rounded-md p-2 text-white hover:bg-green-900 action-tooltip" :href="`/students/show/${props.row.id}`">
                    <svg viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                    <span class="tiptext">vedi scheda</span>
                </a>                
            </span> 
            </span>
            <span v-else>
            {{props.formattedRow[props.column.field]}}
            </span>
        </template>
    </vue-good-table>
    <!-- Pagination controls with rows per page dropdown -->
    <div class="pagination-controls">
      <select class="w-23 p-2" v-model="rowsPerPage" @change="changeRowsPerPage(rowsPerPage)">
        <option :value="10">10</option>
        <option :value="25">25</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
      </select>
      <div class="pagination-buttons">
        <button :disabled="rows.current_page === 1" @click="changePage(rows.current_page - 1)">
          Previous
        </button>
        <span>Page {{ rows.current_page }} of {{ rows.last_page }}</span>
        <button :disabled="rows.current_page === rows.last_page" @click="changePage(rows.current_page + 1)">
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';
import { Form } from 'vform';

export default {
    props: ['students'],
    components : {VueGoodTable},
    name: 'table-students',
  data(){
    return {
       form: new Form({
                id:''
        }),
        searchResults: 0,
        search:'',

      columns: [
        {
          label: 'Cliente',
          field: 'name',
          sortable: true
        },
        {
          label: 'Email',
          field: 'email',
          sortable: true
        },
        {
          label: 'Tel',
          field: 'phone',
          sortable: true
        },
        {
          label: 'Approfondimento',
          field: 'appointment',
          type: 'number',
          sortable: true
        },
        {
          label: 'Evento',
          field: 'event',
          type: 'number',
          sortable: true
        },
        {
          label: 'App',
          field: 'app',
          type: 'number',
          sortable: true
        },
        {
          label: 'Libro',
          field: 'book',
          type: 'number',
          sortable: true
        },
        {
          label: 'Coins',
          field: 'gems',
          type: 'number',
          sortable: true
        },
        {
          label: 'QR',
          field: 'qrcode',
          type: 'number',
          sortable: true
        },
        // {
        //   label: 'Telefono',
        //   field: 'hascontact.phone',
        // },
        {
          label: 'Azioni',
          field: 'action',
          sortable: false
        },
      ],
      rows:this.students,
      rowsPerPage: 50, // Default rows per page
    };
  },
  methods: {
    client(rowObj) {
      return (rowObj.name)+(' ')+(rowObj.last_name);
    },

    async changePage(page) {
      try {
        const response = await this.$inertia.get(`/students?page=${page}`); // Request new page data
        this.students = response.props.students; // Update students with new page data
      } catch (error) {
        console.error('Error loading page:', error);
      }
    },

    async changeRowsPerPage() {
      try {
        const response = await this.$inertia.get(`/students?page=1&per_page=${this.rowsPerPage}`);
        this.rows = response.props.students; // Reset to the first page with new per page
      } catch (error) {
        console.error('Error changing rows per page:', error);
      }
    },

    updateSearchResults() {
      // Update searchResults when input changes
      this.searchResults = 0;
    },
    focusInput() {
      this.$refs.searchInput.focus();
    },

    globalSearch() {
      var custObj = this;
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "applcation/json",
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("/api/global/search",
          { search: this.search },
          { headers }
        )
        .then(function (response) {
          custObj.rows.data = response.data.data.students;
        })
        .catch(function (error) {
          // Swal.fire('Errore', 'qualcosa è andato storto, riprova', 'error');
        });
    },

  },
};
</script>


<style>
.vgt-pagination {
  display: none;
}
.pagination-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.pagination-controls select {
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
  width:7rem;
}

.pagination-buttons button {
  padding: 8px 12px;
  margin: 0 5px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-buttons button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.action-tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.action-tooltip  .tiptext {
  visibility: hidden;
  width: 120px;
  background-color: rgba( 0,0,0, 0.7 );
  color: #fff;
  font-size: 11px;
  text-align: center;
  padding: 4px 0;
  border-radius: 6px;
  position: absolute;
  width: 80px;
  bottom: 105%;
  left: 50%;
  margin-left: -40px;
  z-index: 1;
  }

.action-tooltip:hover .tiptext {
  visibility: visible;
}


.vgt-table.bordered td:nth-child(8) {
  text-align: center;
}

.vgt-table.bordered td:nth-child(8) span{
  display: block;
  width: 28px;
  height: 28px;
  background: #fae3f8;
  border-radius: 100%;
  color: #eb2599;
  font-weight: 600;
  padding-top: 2px;
}

</style>